<div class="row">
    @if(team){
        <div class="col-md-10 mx-auto">
            <admin-team-settings [team]="team" [features]="features" (onChange)="reload()"></admin-team-settings>
        </div>
    }
</div>